import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Form, Formik, FormikProps } from 'formik';
import * as Yup from 'yup';

import { rest } from '@app/components/Api';
import CustomInput from '@app/components/UI/CustomInput/CustomInput';
import '@app/scss/components/login.scss';

interface LoginFormProps {
	setIsLogged?: any;
	match?: any;
}

interface LoginRes {
	success: boolean;
	error?: string;
}

const validationSchema = Yup.object({
	email: Yup.string().email('Value must be a valid Email address').required('Email is a required field'),
	password: Yup.string()
		.matches(/^([0-9a-zA-Z])+$/, 'Password should only contain numbers and letters')
		.required('Password is a required field'),
});

const LoginForm: React.FC<LoginFormProps> = ({ setIsLogged, match }) => {
	const [loginError, setLoginError] = React.useState<string | undefined>('');
	const navigate = useNavigate();

	const PasswordError = ({ loginError }) => {
		const timer = setTimeout(() => {
			setLoginError('');
		}, 5000);
		return <div className="login-form__fields-error">{loginError}</div>;
	};

	return (
		<Formik
			onSubmit={(values) => {
				rest.post<LoginRes>('v1/veterinarianPortal/login', values).then((res) => {
					res.success
						? navigate.arguments(`/veterinary-resources/${match.params?.topic ? match.params.topic : 'about'}/logged`, {
							topic: match ? match.params.topic : '',
						})
						: setLoginError(res.error);
				});
			}}
			initialValues={{
				email: '',
				password: '',
			}}
			validationSchema={validationSchema}
		>
			{(formikBag: FormikProps<any>) => {
				return (
					<Form className="login-form" autoComplete="off">
						<div className="login-form__fields">
							<CustomInput name="email" placeholder="Email" formikBag={formikBag} />
							<CustomInput name="password" placeholder="Password" type="password" formikBag={formikBag} />
							{loginError ? <PasswordError loginError={loginError} /> : null}
						</div>

						<button type="submit" className="btn btn-primary btn-md">
							Log in
						</button>
					</Form>
				);
			}}
		</Formik>
	);
};

export default LoginForm;
